import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const MPKauflandIcon = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Kaufland"
        data-name="Kaufland"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 132.51 106.01"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>Kaufland</title>
        <path
          fill="#e3000f"
          d="m55.05,49.37h-4.03l-5.2,7.26v-7.26h-3.55v15.83h3.55v-7.13l5.2,7.13h4.12l-6.11-8.1,6.02-7.74Zm7.85,6.4c-.63-.61-1.72-1.33-3.23-1.33-2.94,0-4.98,2.44-4.98,5.54s2.01,5.45,4.98,5.45c1.6,0,2.67-.75,3.23-1.31v1.09h3.05v-10.54h-3.05v1.11Zm0,6.06c-.43.48-1.15,1-2.24,1-1.63,0-2.78-1.18-2.78-2.89s1.15-2.9,2.78-2.9c1.09,0,1.81.52,2.24,1v3.8Zm40.76-6.06c-.63-.61-1.72-1.33-3.24-1.33-2.94,0-4.98,2.44-4.98,5.54s2.01,5.45,4.98,5.45c1.61,0,2.67-.75,3.24-1.31v1.09h3.05v-10.54h-3.05v1.11Zm0,6.06c-.43.48-1.15,1-2.24,1-1.63,0-2.78-1.18-2.78-2.89s1.15-2.9,2.78-2.9c1.09,0,1.81.52,2.24,1v3.8Zm-28.1-.25c-.41.52-1.13,1.2-2.26,1.2-1.29,0-2.06-.84-2.06-2.22v-5.9h-3.1v6.52c0,2.49,1.43,4.25,4.05,4.25,1.74,0,2.83-.91,3.37-1.49v1.27h3.05v-10.54h-3.05v6.92Zm11.17-9.88c1.04,0,1.65.45,1.65.45l.5-2.35s-.84-.66-2.83-.66c-2.58,0-4.18,1.49-4.18,4.28v1.24h-1.56v2.53h1.56v8.01h3.14v-8.01h3.57v-2.53h-3.57v-.97c0-1.33.61-1.99,1.72-1.99m3.63,13.5h3.14v-15.83h-3.14v15.83Zm25.01-10.77c-1.72,0-2.83.9-3.35,1.49v-1.27h-3.08v10.54h3.08v-6.92c.39-.54,1.11-1.2,2.26-1.2,1.29,0,2.04.84,2.04,2.22v5.9h3.1v-6.51c0-2.49-1.42-4.25-4.05-4.25m14.08-5.07v6.49c-.54-.57-1.65-1.43-3.35-1.43-2.96,0-4.98,2.44-4.98,5.54s2.06,5.45,4.98,5.45c1.7,0,2.81-.84,3.35-1.42v1.2h3.05v-15.83h-3.05Zm0,12.33c-.41.52-1.18,1.13-2.35,1.13-1.63,0-2.78-1.18-2.78-2.89s1.15-2.9,2.78-2.9c1.18,0,1.95.61,2.35,1.13v3.53Z"
        />
        <path
          fill="#e3000f"
          d="m0,71.29h36.56v-36.56H0v36.56Zm34.56-2H2v-32.56h32.56v32.56Z"
        />
        <path fill="#e3000f" d="m6.07,40.8h11.25v11.25H6.07v-11.25Z" />
        <path fill="#e3000f" d="m6.06,53.96h11.25v11.25H6.06v-11.25Z" />
        <path fill="#e3000f" d="m19.24,65.21h11.26l-11.26-11.26v11.26Z" />
        <path fill="#e3000f" d="m19.24,40.79v11.26l11.26-11.26h-11.26Z" />
      </svg>
    </SvgIcon>
  );
};

export default MPKauflandIcon;
